import { useEstabsContext } from '../../contexts/EstabsContext';
import { zonedDate } from '../../utils/date-time';
import React, { createContext, ReactNode, useContext, useState } from 'react';
import moment from 'moment';

interface DashboardContextType {
    selectedDate: string;
    setSelectedDate: (date: string) => void;
    startAt: string;
    endAt: string;
    setStartAt: (date: string) => void;
    setEndAt: (date: string) => void;
    atendenteId: string;
    setAtendenteId: (atendenteId: string) => void;
}

const DashboardContext = createContext<DashboardContextType | undefined>(undefined);

export const DashboardProvider = ({ children }: { children: ReactNode }) => {
    const { estabSession } = useEstabsContext();
    const [atendenteId, setAtendenteIdState] = useState<string>(() => {
        const stored = sessionStorage.getItem('dashboardAtendenteId');
        return stored || '';
    });

    const [selectedDate, setselectedDateState] = useState<string>(() => {
        const stored = sessionStorage.getItem('dashboardSelectedDate');
        return stored || zonedDate(new Date(), estabSession?.timezone).format('YYYY-MM-DD');
    });

    const [startAt, setStartAtState] = useState<string>(() => {
        const stored = sessionStorage.getItem('dashboardStartAt');
        return stored || zonedDate(new Date(), estabSession?.timezone).startOf('month').format('YYYY-MM-DD');
    });

    const [endAt, setEndAtState] = useState<string>(() => {
        const stored = sessionStorage.getItem('dashboardEndAt');
        return stored || zonedDate(new Date(), estabSession?.timezone).format('YYYY-MM-DD');
    });

    const setAtendenteId = (id: string) => {
        setAtendenteIdState(id);
        sessionStorage.setItem('dashboardAtendenteId', id);
    };

    const setSelectedDate = (date: string) => {
        setselectedDateState(date);
        sessionStorage.setItem('dashboardSelectedDate', date);
        setStartAtState(date);
        setEndAtState(date);
        sessionStorage.setItem('dashboardStartAt', date);
        sessionStorage.setItem('dashboardEndAt', date);
    };

    const setStartAt = (date: string) => {
        setStartAtState(date);
        sessionStorage.setItem('dashboardStartAt', date);
    };

    const setEndAt = (date: string) => {
        setEndAtState(date);
        sessionStorage.setItem('dashboardEndAt', date);
        setselectedDateState(date);
        sessionStorage.setItem('dashboardSelectedDate', date);
    };

    return (
        <DashboardContext.Provider
            value={{
                selectedDate,
                setSelectedDate,
                startAt,
                endAt,
                setStartAt,
                setEndAt,
                atendenteId,
                setAtendenteId,
            }}
        >
            {children}
        </DashboardContext.Provider>
    );
};

export const useDashboardContext = (): DashboardContextType => {
    const context = useContext(DashboardContext);
    if (!context) {
        throw new Error('useDashboardContext must be used within a DashboardProvider');
    }
    return context;
};
